module.exports = __webpack_public_path__ + "static/media/Group.722c0644.svg";